import { EventActions } from '../actions'
import { handleError } from '../handle-error'
import type { EventView } from '../types'

export const debouncedSetProductQuantity = (
    view: EventView,
    variantId: number,
    quantity: number,
): void => {
    const key = 'set-product-quantity-' + variantId
    const prevTimeout = view.timeouts.get(key)
    clearTimeout(prevTimeout)

    const newTimeout = window.setTimeout(() => {
        try {
            void EventActions.setProductVariantQuantity(view, variantId, quantity)
        } catch (error) {
            handleError(view, error as Error)
        }
    }, 300)

    view.timeouts.set(key, newTimeout)
}
